export interface CustomerDocument {
  id: string;
  customerId: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  fileUrl: string;
  uploadDate: string;
  uploadedBy: string;
  uploadedByName: string;
  description?: string;
  category?: string;
}

export interface DocumentUpload {
  file: File;
  description?: string;
  category?: string;
}

export type DocumentCategory = 'invoice' | 'contract' | 'correspondence' | 'statement' | 'credit_application' | 'other';

export const DOCUMENT_CATEGORIES: { value: DocumentCategory; label: string }[] = [
  { value: 'invoice', label: 'Invoice' },
  { value: 'contract', label: 'Contract' },
  { value: 'correspondence', label: 'Correspondence' },
  { value: 'statement', label: 'Statement' },
  { value: 'credit_application', label: 'Credit Application' },
  { value: 'other', label: 'Other' },
];

export const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
